export default class Locale_DataService {
	FailedQuerying: string = "Failed querying";
	FailedGetting: string = "Failed getting";
	FailedUpserting: string = "Failed upserting";
	FailedDeleting: string = "Failed deleting";
}